module.exports = __webpack_public_path__ + "static/media/back-arrow-header.4fb67874.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/back-arrow-header.svg
// module id = 297
// module chunks = 0